import React from 'react'
import { useSelector } from 'react-redux'
import { eventSelector, eventModalSelector } from 'src/selectors'
import Flier from 'src/components/details/Flier'

import ChatSection from './ChatSection/ChatSection'

import styles from './flyer-container.scss'

const FlyerContainer = () => {
  const event = useSelector(eventSelector)
  const eventModal = useSelector(eventModalSelector)

  const renderFlyer = () => {
    return <Flier event={event} />
  }

  const isGroupVisible = eventModal === 'chat'

  return (
    <div className={styles['flyer-container']}>
      {renderFlyer()}
      {isGroupVisible && <ChatSection />}
    </div>
  )
}

export default FlyerContainer
